// extracted by mini-css-extract-plugin
export default {"container":"RefText_container__+6Di3","refMode":"RefText_refMode__7QUxW","clickable":"RefText_clickable__8i2RD","important":"RefText_important__WQL+8","close":"RefText_close__273fC"};